import * as React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"

import Tags from "Catalog/Preview/shared/components/Tags"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import { IProductOrDeal, isDeal } from "shared/hubrise/models"
import * as Sku from "shared/hubrise/utils/Sku"

import {
  Description,
  EditButton,
  EditIcon,
  Image,
  Info,
  Name,
  NameAndTags,
  Price,
  PriceAndSize,
  Size,
  StyledProductOrDeal,
} from "./Styles"

interface ProductProps {
  productOrDeal: IProductOrDeal
  className?: string
}

const ProductOrDeal = ({ productOrDeal, className }: ProductProps): JSX.Element => {
  const { t } = useTranslation()
  const params = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { catalogNavigation, variantRef } = useCatalogNavigation()

  const imageHrId = productOrDeal.imageHrIds[0]
  const imagePath = imageHrId ? catalogNavigation.imagePath(imageHrId) : undefined
  const hasImage = imagePath !== undefined

  const htmlPrice = isDeal(productOrDeal) ? "" : Sku.price(productOrDeal.skus[0], variantRef).toHumanString()
  const isMultiSku = !isDeal(productOrDeal) && productOrDeal.skus.length > 1

  const previewPath = isDeal(productOrDeal)
    ? catalogNavigation.previewPath("deal", productOrDeal.id)
    : catalogNavigation.previewPath("product", productOrDeal.id)
  const editPath = isDeal(productOrDeal)
    ? catalogNavigation.editPath("deal", productOrDeal.id)
    : catalogNavigation.editPath("product", productOrDeal.id)

  const handleEdit = (event: React.MouseEvent) => {
    event.stopPropagation()
    navigate(editPath)
  }

  return (
    <StyledProductOrDeal
      className={className}
      data-item-id={productOrDeal.id}
      hasImage={hasImage}
      onClick={() => navigate(previewPath)}
      isSelected={params.id === productOrDeal.id.toString()}
    >
      <Info>
        <NameAndTags>
          <Name>{productOrDeal.name}</Name>
          {!isDeal(productOrDeal) && <Tags tags={productOrDeal.tags} />}
        </NameAndTags>

        {productOrDeal.description && <Description dangerouslySetInnerHTML={{ __html: productOrDeal.description }} />}

        <PriceAndSize>
          <Price dangerouslySetInnerHTML={{ __html: htmlPrice }} />
          {isMultiSku && <Size>{t("preview.multiskus")}</Size>}
        </PriceAndSize>
      </Info>

      {hasImage && <Image src={imagePath} alt={productOrDeal.name} />}

      <EditButton onClick={handleEdit}>
        <EditIcon />
      </EditButton>
    </StyledProductOrDeal>
  )
}

export default ProductOrDeal
